import React from 'react';
import { Container, Row, Col, ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Devops.scss';

const PRODUCTION_URL = 'https://p01--farfars-messages--qpyrdxdqxysc.code.run/';
const NORTHFLANK_DASHBOARD =
  'https://app.northflank.com/t/bjorntes-team/project/farfars-messages/service/farfars-messages';

function Devops() {
  return (
    <div className="main-content">
      <Container className="mb-5">
        <h1 className="display-4 mt-3">Devops</h1>
        <Row>
          <Col className="col-12 col-md-6 col-lg-8">
            <h2 className="display-6 mt-3">Stack</h2>
            <p>
              React 18 (TypeScript, Create React App) talks to Express 4 (JavaScript, Node 18+).
              Lasting data is MongoDB Atlas via Mongoose. Photos live on Cloudinary.
              Live updates share Express’s HTTP port as WebSockets (<code>/ws</code>).
              Production is Northflank; Express serves the React build from the same origin.
            </p>
            <p className="mb-1">Locally: React on port 3000, Express on 3001. From <code>express/</code> run <code>npm run dev</code>.</p>
            <p>
              Client-side encryption (ECDH P-256, AES-GCM) is turned on from{' '}
              <Link to="/settings">Settings</Link>. Keyholders use{' '}
              <Link to="/recovery">Recovery circle</Link>, not reusable share files.
            </p>
            <ul>
              <li><Link to="/show-md?n=stack">Tech stack</Link></li>
              <li><Link to="/show-md">All documentation</Link>, including the <Link to="/show-md?n=1-main-prompt">main prompt</Link></li>
              <li><Link to="/show-md?n=how-to-run">How to run</Link></li>
              <li><Link to="/user-threads">User–thread map</Link></li>
            </ul>
            <p className="text-muted mt-4">
              First commit:{' '}
              <a href="https://github.com/bjornte/transparent-encryption/commit/fdc2a25e1198a95780b76090e331094c30cf8b63">
                22 March 2016
              </a>
              , as “Transparent encryption”. This React app started 25 June 2024.
            </p>
          </Col>
          <Col className="col-12 col-md-6 col-lg-4">
            <h2 className="display-6 mt-3">URLs</h2>
            <ListGroup>
              <ListGroup.Item action href={PRODUCTION_URL} target="_blank" rel="noreferrer">
                Production (Northflank)
              </ListGroup.Item>
              <ListGroup.Item action href={NORTHFLANK_DASHBOARD} target="_blank" rel="noreferrer">
                Northflank dashboard
              </ListGroup.Item>
              <ListGroup.Item action href="http://localhost:3000/">
                Local React (port 3000)
              </ListGroup.Item>
              <ListGroup.Item action href="http://localhost:3001/">
                Local Express (port 3001)
              </ListGroup.Item>
              <ListGroup.Item action href="https://cloud.mongodb.com" target="_blank" rel="noreferrer">
                MongoDB Atlas
              </ListGroup.Item>
            </ListGroup>
            <p className="small text-muted mt-2 mb-0">
              Local Mongo is optional. Express tries <code>MONGO_URI</code>, then <code>127.0.0.1:27017</code>,
              then an in-memory database that is wiped on restart.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Devops;
